require('videogular');
require('./vg-controls');

module.exports = 'com.2fdevs.videogular.plugins.controls';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-controls/index.js
// module id = 78
// module chunks = 0